import { fetchUserToken } from 'lib/services/mobivers/auth';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';

export const VendorTest = () => {
	const [refreshToken, setRefreshToken] = useState('');

	const handleFetchToken = async () => {
		const username = prompt('Username', 'verkaeufer1@autohaus.dau');
		const password = prompt('Password', 'Start100!');
		if (username && password) {
			try {
				const result = await fetchUserToken(username, password);

				setRefreshToken(result.refresh_token);
			} catch (e) {
				alert('Bad Credentials');
			}
		} else {
			alert('Username and Password are required to perform this operation.');
		}
	};

	const { register } = useForm({
		defaultValues: {
			partnerId: 'test_data',
			partnerNumber: 'test_data',
			name: 'Max',
			surname: 'Muster',
			email: 'foo@bar.de',
			telephone: '040 1234567',
			birthDate: '1982-03-02',
			streetName: 'Musterstr.',
			streetNumber: '99b',
			postalCode: '98765',
			addressLocality: 'Musterstadt',
			iban: 'DE65 1203 0000 1033 4469 54',
			isNewCar: 'true',
		},
	});

	const [action, setAction] = useState(
		'https://nonlive.mobivers.orbitdigital.space/dms'
	);

	return (
		<div className="root">
			<style
				dangerouslySetInnerHTML={{
					__html: `
				label {
					width: 200px;
					display: inline-block;
				}
				input {
					width: 300px;
					display: inline-block;
				}
				span {
					padding-left: 8px;
					font-family: monospace;
				}
				.root {
					padding: 8px;
				}
				button.submit {
					background-color: #ccc;
					padding: 8px;
				}
			`,
				}}
			/>
			<h3>DMS-test</h3>
			<div>
				<label onClick={() => setAction('http://localhost:8080/dms')}>
					<strong>action</strong>
				</label>
				<input
					type="text"
					value={action}
					onChange={(e) => setAction(e.target.value)}
				/>
			</div>
			<div>
				<label>
					<strong>generate token</strong>
				</label>
				<button onClick={handleFetchToken}>fetch token</button>
			</div>
			<br />
			<form action={action} method="post">
				<div style={{ display: 'flex', flexDirection: 'column' }}>
					<div>
						<label>partnerId</label>
						<input type="text" {...register('partnerId')} />
						<span>
							string <strong>required</strong>
						</span>
					</div>
					<div>
						<label>partnerNumber</label>
						<input type="text" {...register('partnerNumber')} />
						<span>
							string <strong>required</strong>
						</span>
					</div>

					<div>
						<label>refreshToken</label>
						<input
							type="text"
							name="refreshToken"
							value={refreshToken}
							onChange={(e) => setRefreshToken(e.target.value)}
						/>
						<span>
							string <strong>required </strong>
						</span>
					</div>

					<div>
						<label>name</label>
						<input type="text" {...register('name')} />
						<span>string</span>
					</div>
					<div>
						<label>surname</label>
						<input type="text" {...register('surname')} />
						<span>string</span>
					</div>
					<div>
						<label>email</label>
						<input type="text" {...register('email')} />
						<span>string</span>
					</div>
					<div>
						<label>telephone</label>
						<input type="text" {...register('telephone')} />
						<span>string</span>
					</div>
					<div>
						<label>birthDate</label>
						<input type="text" {...register('birthDate')} />
						<span>string (YYYY-MM-DD)</span>
					</div>
					<div>
						<label>streetName</label>
						<input type="text" {...register('streetName')} />
						<span>string</span>
					</div>
					<div>
						<label>streetNumber</label>
						<input type="text" {...register('streetNumber')} />
						<span>string</span>
					</div>
					<div>
						<label>postalCode</label>
						<input type="text" {...register('postalCode')} />
						<span>string</span>
					</div>
					<div>
						<label>addressLocality</label>
						<input type="text" {...register('addressLocality')} />
						<span>string</span>
					</div>
					<div>
						<label>iban</label>
						<input type="text" {...register('iban')} />
						<span>string</span>
					</div>
					<div>
						<label>isNewCar</label>
						<input type="text" {...register('isNewCar')} />
						<span>string (true | false)</span>
					</div>

					<div>
						<button className="submit" type="submit">
							submit data
						</button>
					</div>
				</div>
			</form>
		</div>
	);
};
